import { Component, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';

@Component({
    selector: 'wm-test-input-activity-editor',
    imports: [],
    templateUrl: './test-input-activity-editor.component.html',
    styleUrl: './test-input-activity-editor.component.css'
})
export class TestInputActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {}
